import {
	SET_LIST_PRODUCTS_ACTION,
	SET_CALCULLATE_CART_ACTION,
	SET_SELECT_PRODUCT_DRAFT_ACTION,
	SET_DATA_CALCALATE_CART_ACTION,
	SET_CART_ACTION,
	SET_LIST_HISTORY_ORDER_ACTION,
	SET_DATA_HISTORY_DETAIL_ACTION,
	SET_ORDER_HISTORY_DETAIL_ACTION,
	SET_DATA_ID_PROMOTION_CHOOSES_ACTION,
	SET_MENU_CHILDREN_HISTORY_ACTION,
	SET_MENU_PARENT_HISTORY_ACTION,
	SET_MENU_PRODUCT_BRANDS_ACTION
} from "../actions/OrderPageAction/actionTypes";
import storage from "redux-persist/lib/storage";
import { persistReducer } from "redux-persist";

const persistConfig = {
	key: "carts",
	storage: storage
};

const initialState = {
	carts: [],
	listProduct: [],
	totalListProduct: 0,
	dataCalculateCart: {},
	listProductDraft: [],
	infoDataCalculate: {},
	listHistoryOrder: {},
	infoHistoryDetails: {},
	listOrderHistoryDetails: {},
	dataIdPromotionChooses: [],
	menuChildren: 0,
	menuParent: "SALE",
	menuProductBrands: {}
};

// Receive signal of action -> return new state
const orderPageReducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_LIST_PRODUCTS_ACTION: {
			return {
				...state,
				listProduct: action.params.products,
				totalListProduct: action.params.total
			};
		}
		case SET_CALCULLATE_CART_ACTION: {
			return {
				...state,
				dataCalculateCart: action.params
			};
		}
		case SET_SELECT_PRODUCT_DRAFT_ACTION: {
			return {
				...state,
				listProductDraft: action.params
			};
		}
		case SET_DATA_CALCALATE_CART_ACTION: {
			return {
				...state,
				infoDataCalculate: action.params
			};
		}
		case SET_CART_ACTION: {
			return {
				...state,
				carts: action.params
			};
		}
		case SET_LIST_HISTORY_ORDER_ACTION: {
			return {
				...state,
				listHistoryOrder: action.params.data
			};
		}
		case SET_DATA_HISTORY_DETAIL_ACTION: {
			return {
				...state,
				infoHistoryDetails: action.params
			};
		}
		case SET_ORDER_HISTORY_DETAIL_ACTION: {
			return {
				...state,
				listOrderHistoryDetails: action.params.order
					? action.params.order
					: {}
			};
		}
		case SET_DATA_ID_PROMOTION_CHOOSES_ACTION: {
			return {
				...state,
				dataIdPromotionChooses: action.params
			};
		}
		case SET_MENU_CHILDREN_HISTORY_ACTION: {
			return {
				...state,
				menuChildren: action.params
			};
		}
		case SET_MENU_PARENT_HISTORY_ACTION: {
			return {
				...state,
				menuParent: action.params
			};
		}
		case SET_MENU_PRODUCT_BRANDS_ACTION: {
			return {
				...state,
				menuProductBrands: action.params
			};
		}
		default:
			return state;
	}
};

export default persistReducer(persistConfig, orderPageReducer);
